import React from 'react';
import { useHistory } from 'react-router-dom';

import { Button } from '../../Atoms';
import Congratulations from './Congratulations';

const Feedback = ({ isClevel }) => {
  const history = useHistory();

  const handleClick = () => {
    history.push('/feedback');
  };
  return (
    <div className="manager-feedback">
      {isClevel && <Congratulations isFeedback />}
      <div>
        Your report and custom action steps are now available for you to review.
        Feel free to drop us a line and tell us what you think of the survey.
      </div>
      <Button size="lg" color="blue" onClick={handleClick}>
        Send us your feedback
      </Button>
    </div>
  );
};

export default Feedback;
